import { useMutation } from '@tanstack/react-query';

import type { TOptions } from '@core/api/request';
import { request } from '@core/api/request';

import type { TImage } from '@shared/types/image';

export const uploadMedia = async (file: File, options?: Partial<TOptions>) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mime_type', file?.type);
  const res = await request<TImage>({
    url: `media/`,
    method: 'POST',
    body: formData,
    ...options,
  });

  return res;
};

export const useUploadMedia = () => {
  return useMutation({
    mutationFn: ({
      file,
      options,
    }: {
      file: File;
      options?: Partial<TOptions>;
    }) => uploadMedia(file, options),
  });
};
